"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modifiers = void 0;
var react_1 = __importStar(require("react"));
var Modifiers = function (_a) {
    var modifiers = _a.modifiers, title = _a.title;
    return modifiers === undefined ? null : (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("p", { className: "f3 mb1 mt2" }, title),
        react_1.default.createElement("div", { className: "d-f" },
            react_1.default.createElement("div", { className: "mr2" }, Object.keys(modifiers).map(function (key) { return (react_1.default.createElement("p", { key: "nk".concat(key) }, key)); })),
            react_1.default.createElement("div", { className: "grow" }, Object.values(modifiers).map(function (val) { return (react_1.default.createElement("p", { key: "nv".concat(val) }, "= ".concat(val))); })))));
};
exports.Modifiers = Modifiers;
